import { Button, Grid, Paper, Typography } from '@material-ui/core';
import React from 'react';
import NavBar from '../components/navbar';
import OverviewCard from '../components/overviewcard';
import { zip } from '../data/downloads';
import index from '../data/downloads';

class Download extends React.Component {

    render() {
        return (
            <>
                <NavBar />
                <Paper>
                    <Grid
                        container
                        justify="space-between"
                        alignItems="center"
                        direction="row"
                    >
                        <Grid item key={'title'}><Typography variant="h2">Grundwissen herunterladen</Typography></Grid>
                        <Grid item key={'button'} ><Button variant="contained" onClick={e => this.download(zip, 'Grundwissen')}><Typography variant="h5">Alles herunterladen</Typography></Button></Grid>
                    </Grid>
                </Paper>
                <Grid
                    container
                    justify="center"
                    alignItems="center"
                >
                    {
                        Object.keys(index).map(klasse => {
                            let buttons = [];
                            index[klasse].forEach(element => {
                                buttons.push({ 'name': element['title'], 'onClick': e => this.download(element['data'], 'Grundwissen ' + klasse + ' ' + element['title']) });
                            });
                            return (
                                <Grid container item key={klasse}>
                                    <OverviewCard title={klasse + '. Klasse'} description={''} buttons={buttons} />
                                </Grid>
                            );
                        })
                    }
                </Grid>
            </>
        );
    }

    async download(file, name) {
        var element = document.createElement('a');
        element.setAttribute('href', file);
        element.setAttribute('download', name);
        element.setAttribute('target', '_blank');
        element.setAttribute('rel', 'noopener noreferrer');
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

}

export default Download;